import React, { Fragment } from "react";
import styled from "styled-components";

import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

import { CheckboxLabel, CheckboxInput } from "components/CheckboxLabel";

import ElectricalModule from "images/electrical_module.png";

import { formPropTypes } from "./prop-types";
import { FormPartial, Title, StyledP2, Checkboxes, Input } from "../styles";

const ElectricalImg = styled.img`
  display: block;
  height: 120px;
  object-fit: contain;
  margin: 16px auto;
  max-width: 120px;
  width: auto;

  @media screen and (min-width: ${getSize("tablet720")}) {
    height: 154px;
    margin: 0px;
    margin-left: 28px;
    max-width: 154px;
  }
`;

export const ElectricalDetailsForm = ({ base }) => {
  return (
    <Fragment>
      <Title id="foo">Electrical Details</Title>
      <div
        css={`
          display: contents;
          @media screen and (min-width: ${getSize("tablet720")}) {
            align-items: center;
            display: flex;
            flex-flow: row-reverse nowrap;
            margin: 4px 0 30px 0;
          }
        `}
      >
        <ElectricalImg src={ElectricalModule} alt="Electrical diagram icon" />
        <StyledP2
          css={`
            @media screen and (min-width: ${getSize("tablet720")}) {
              margin: 0;
            }
          `}
        >
          {
            "For a more accurate estimate, let’s learn a little more about your current electrical service. This information may be found on the inside of your main electrical panel door."
          }
        </StyledP2>
      </div>
      <FormPartial>
        <Input
          placeholder="Service Amperage*"
          name={base("ServiceAmperage")}
          required
          type="text"
        />
        <Input
          placeholder="Voltage*"
          name={base("Voltage")}
          required
          type="text"
        />
      </FormPartial>
      <Checkboxes>
        <CheckboxLabel>
          <CheckboxInput name={base("SinglePhase")} type="checkbox" />
          <span>{"Single Phase"}</span>
        </CheckboxLabel>
        <CheckboxLabel>
          <CheckboxInput name={base("ThreePhase")} type="checkbox" />
          <span>{"Three Phase"}</span>
        </CheckboxLabel>
      </Checkboxes>
    </Fragment>
  );
};

ElectricalDetailsForm.propTypes = formPropTypes;
